import {PlaceholderValue} from '@olive/placeholder-util-browser';

class EnvironmentVariables {
  variables: { [key: string]: PlaceholderValue }

  init(variables: { [key: string]: PlaceholderValue }) {
    this.variables = variables;
  }

  getAll()
  {
    return this.variables;
  }
}

const ENV_VARS = new EnvironmentVariables();

export default ENV_VARS;